import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { MERCHANT_COMMERCIAL, FLAT_FEE, IS_CHARGE_ON_CUSTOMER, PARTNER_COMMISSION } from './const';

const labelTooltipMap = {
  [IS_CHARGE_ON_CUSTOMER]: {
    label: 'Surcharge',
    tooltip: 'Platform Fee on customer.'
  },
  [MERCHANT_COMMERCIAL]: {
    label: 'Charge',
    tooltip: 'Platform Fee.'
  },
  [PARTNER_COMMISSION]: {
    label: 'Commission',
    tooltip: 'The percentage/fixed amount paid to a partner for transactions.'
  },
  [FLAT_FEE]: {
    label: 'Flat Fee',
    tooltip: 'Fixed amount charged for the transaction in addition to Platform Fee.'
  }
};

function CustomTooltip(props) {
  const { label } = props;
  const entry = labelTooltipMap[label] || {};
  const { label: displayLabel = label, tooltip } = entry;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {displayLabel}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoCircleOutlined style={{ cursor: 'pointer', color: '#8c8c8c' }} />
        </Tooltip>
      )}
    </span>
  );
}

CustomTooltip.propTypes = {
  label: PropTypes.string.isRequired
};

export default CustomTooltip;
